<script>
import ERow from "@/components/layout/components/Row"
import ECol from "@/components/layout/components/Col"
import {UBtnDropdown, UList, CloseOverlay} from 'uloc-vue'
import Campanha from "@/components/marketing/components/Campanha";

export default {
  name: 'Marketing',
  inject: {
    erplayout: {
      default() {
        console.error('Main needs to be child of ErpLayout')
      }
    }
  },
  directives: {CloseOverlay},
  components: {
    Campanha,
    ECol,
    ERow,
    UBtnDropdown, UList
    // Layout,
  },
  data() {
    return {}
  },
  computed: {},
  mounted() {
    this.erplayout.erpheader.menu.setActiveMenu('marketing')
  },
  destroyed() {
    // document.querySelector('.u-erp-layout-container').classList.remove('bg-white')
  },
  methods: {},
  meta: {
    title: 'Marketing',
    name: 'Marketing'
  }
}
</script>

<template>
  <transition name="slide" appear>
    <div class="transition-generic w-full wrapper-lg">
      <e-row>
        <e-col><h2 class="title">Comunicação e Marketing</h2></e-col>
        <e-col class="text-right">
          <div class="u-btn-group-container">
            <u-btn disable label="Criar Campanha" @click="$router.push({name: 'marketing.criar-campanha'})" no-caps color="dark"/>
            <!--              <u-btn icon="caret-down" icon-type="fa" no-caps color="dark" class="btn-right" />-->
            <u-btn-dropdown
                color="dark"
                :popover-offset="[0, 4]"
            >
              <u-list class="list-default flex column" link>
                <u-btn class="u-btn-list" v-close-overlay align="left" label="Campanha de Email" icon="envelope"
                       icon-type="fa" icon-style="light" flat no-caps/>
                <u-btn class="u-btn-list" align="left" label="SMS" icon="mobile" icon-type="fa" icon-style="light"
                       flat no-caps/>
                <u-btn class="u-btn-list" align="left" label="WhatsApp" icon="whatsapp" icon-type="fa"
                       icon-style="brand" flat no-caps/>
                <u-btn class="u-btn-list" align="left" label="Voz" icon="phone" icon-type="fa" icon-style="light"
                       flat no-caps/>
              </u-list>
            </u-btn-dropdown>
          </div>

        </e-col>
      </e-row>

      <e-row class="m-t-md">
        <e-col>
          <u-btn-dropdown
              color="grey-4"
              text-color="black"
              no-caps
              label="Filtros"
              :popover-offset="[0, 4]"

          >
            <u-list class="list-default" style="min-width: 280px;" link>
              <div class="wrapper-md">
                <e-row>
                  <e-col>Status</e-col>
                </e-row>
                <e-row>
                  <e-col>
                    <select class="form-control">
                      <option>Tudo</option>
                      <option>Rascunho</option>
                      <option>Programado</option>
                      <option>Pausado</option>
                      <option>Em andamento</option>
                      <option>Concluído</option>
                    </select>
                  </e-col>
                </e-row>
                <e-row class="m-t-xs">
                  <e-col>Canal</e-col>
                </e-row>
                <e-row>
                  <e-col>
                    <select class="form-control">
                      <option>Tudo</option>
                      <option>Email</option>
                      <option>Voz</option>
                      <option>SMS</option>
                      <option>Whatsapp</option>
                    </select>
                  </e-col>
                </e-row>
                <e-row>
                  <e-col>
                    <u-btn no-caps color="positive" label="Aplicar"/>
                  </e-col>
                  <e-col class="text-right">
                    <u-btn no-caps color="grey-3" text-color="black" label="Limpar filtros"/>
                  </e-col>
                </e-row>
              </div>
            </u-list>
          </u-btn-dropdown>
        </e-col>
      </e-row>

      <campanha v-if="false"/>
      <div class="m-t">
        Para iniciar novas campanhas, configure os canais, transmissores e temas primeiro.
      </div>
    </div>
  </transition>
</template>

